import { useEffect, useState } from 'react'
import emocionarioLogo from '../../../assets/images/emocionario.png'
import questionarioSeduc from '../../../assets/images/questionario-seduc.png'
import logoFoco from '../../../assets/images/logo-foco.png'
import concursoLogo from '../../../assets/images/concurso.png'
import { Row } from '../Grid/Grid'
import {
  FlexWrapper,
  InfoButton,
  InfoButtonHref,
  InfoCardContent,
  InfoCardContentMobile,
  InfoCardHeader,
  InfoCardTabs,
  InfoDescription,
  InfoImage,
  InfoSubDescription,
  InfoTitle,
} from './style'
import { useRecoilValue } from 'recoil'
import UserState from '../../../store/UserAtom'
import api from '../../../services/api'

const tabsContent: { [key: string]: any } = {
  elegibilidadePeDeMeia: {
    title: 'Informações Pé de Meia',
    logo: emocionarioLogo,
    links: [
      {
        label: 'Saiba mais',
        href: 'https://goias.gov.br/programa-pe-de-meia-e-lancado-em-goias',
      },
    ],
  },
  acervoAulas: {
    title: 'Acervo de aulas',
    logo: emocionarioLogo,
    description:
      'Clique para ver o nosso acervo de aulas.',
    links: [
      {
        label: 'Ver Aulas',
        path: '/aulas',
      },
    ],
  },
  formularioSouPaiMaeAluno: {
    title: 'Pesquisa do Programa Sou Pai/Mãe e Sou Aluno',
    logo: questionarioSeduc,
    description: 'Pesquisa do Programa Sou Pai/Mãe e Sou Aluno',
    links: [
      {
        label: 'Ver Formulário',
        href: process.env.REACT_APP_FORMULARIO_SOCIOECONOMICO,
      },
    ],
  },
  concursoLiterario: {
    title: 'Concurso Literário',
    logo: concursoLogo,
    description:
      'Projeto interdisciplinar que visa identificar, valorizar e dar visibilidade à produção cultural dos/das estudantes.',
    links: [
      {
        label: 'Saiba Mais',
        href: 'https://cirandadaarte.com.br/ccl-concurso-cenico-literario',
      },
    ],
  },
  focoAprendizagem: {
    title: 'Foco na Aprendizagem',
    logo: logoFoco,
    description:
      'Conjunto de Atividades Preparatórias de língua portuguesa e matemática para Simulados, a fim de melhorar a proficiência do estudante de 2º, 5º e 9º anos do ensino fundamental.',
    links: [
      {
        label: '2° Ano',
        path: '/conteudos/foco_aprendizagem/170/?turma=2º Ano&title=Foco na Aprendizagem',
      },
      {
        label: '5° Ano',
        path: '/conteudos/foco_aprendizagem/171/?turma=5º Ano&title=Foco na Aprendizagem',
      },
      {
        label: '9° Ano',
        path: '/conteudos/foco_aprendizagem/172/?turma=9º Ano&title=Foco na Aprendizagem',
      },
    ],
  },
  denunciaBullying: {
    title: 'Denúncia de Bullying',
    logo: concursoLogo,
    description:
      'Se você pesenciou ou sofreu bullying, utilize este formulário para nos informar.',
    links: [
      {
        label: 'Ver Formulário',
        href: 'https://denunciaescolar.educacao.go.gov.br',
      },
    ],
  },
  boletimEscolar: {
    title: 'Boletim Escolar',
    logo: questionarioSeduc,
    description: 'Acesse o Expresso para emitir o Boletim Escolar.',
    links: [
      {
        label: 'Ver Boletim Escolar',
        href: 'https://www.go.gov.br/servicos/servico/solicitar-boletim-escolar-da-rede-estadual-de-educacao',
      },
    ],
  },
  merendaEscolar: {
    title: 'Questionário Merenda Escolar',
    logo: questionarioSeduc,
    description: 'Acesse o questionário para avaliar a alimentação escolar.',
    links: [
      {
        label: 'Ver Questionário de Merenda',
        href: 'https://questionariomerenda.educacao.go.gov.br/QuestionarioMerenda/Inicio.aspx',
      },
    ],
  },
  acessarSimulado: {
    title: 'Acessar Simulado',
    logo: questionarioSeduc,
    description: 'Clique em "Acessar Simulado" para acessá-lo.',
    links: [
      {
        label: 'Acessar Simulado',
        href: 'https://avaliacao.educacao.go.gov.br',
      },
    ],
  },
}

export const TabsSection = () => {
  const user = useRecoilValue(UserState)
  const [activeTab, setActiveTab] = useState<string>('elegibilidadePeDeMeia')
  const linkMerenda = `https://questionariomerenda.educacao.go.gov.br/QuestionarioMerenda/Inicio.aspx?matricula=${user?.matricula}&escola=${user?.codigoEscola}&ano=${user?.anoLetivo}`
  const linkDenunciaEscolar = `${process.env.REACT_APP_DENUNCIA_ESCOLAR}?token=${user?.authToken}`;

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`${process.env.REACT_APP_PE_DE_MEIA}/Elegibilidade/cpfNis?cpfNis=${user?.cpf}`);

        tabsContent.elegibilidadePeDeMeia.subDescription = data?.nomeSituacao || "Não está disponível.";
        tabsContent.elegibilidadePeDeMeia.description = data?.descricaoSituacao;
      } catch {
        tabsContent.elegibilidadePeDeMeia.subDescription = "";
        tabsContent.elegibilidadePeDeMeia.description = "Não está disponível.";
      } finally {
        setActiveTab('elegibilidadePeDeMeia');
      }
    })();
  }, [user]);

  return (
    <FlexWrapper>
      <InfoCardTabs>
        {Object.entries(tabsContent).map(([key, tab]) => (
          <div key={key}>
            <InfoCardHeader active={activeTab === key} onClick={() => setActiveTab(key)}>
              <InfoImage src={tab.logo} />
              <InfoTitle>{tab.title}</InfoTitle>
            </InfoCardHeader>

            <InfoCardContentMobile active={activeTab === key}>
              <InfoImage src={tab.logo} />
              <InfoSubDescription>{tab.subDescription}</InfoSubDescription>
              <InfoDescription>{tab.description}</InfoDescription>
              <Row justify="center" align="center">
                {tab.links?.map((link: any) =>
                  link.href ? (
                    <InfoButtonHref
                      key={link.label}
                      href={
                        tab.title === 'Questionário Merenda Escolar' 
                          ? linkMerenda 
                          : tab.title === 'Denúncia de Bullying' 
                          ? linkDenunciaEscolar 
                          : link.href
                      }
                      target="_blank"
                    >
                      {link.label}
                    </InfoButtonHref>
                  ) : (
                    <InfoButton key={link.label} to={link.path}>
                      {link.label}
                    </InfoButton>
                  ),
                )}
              </Row>
            </InfoCardContentMobile>
          </div>
        ))}
      </InfoCardTabs>

      <InfoCardContent>
        <InfoImage src={tabsContent[activeTab].logo} />
        <InfoSubDescription>{tabsContent[activeTab].subDescription}</InfoSubDescription>
        <InfoDescription>{tabsContent[activeTab].description}</InfoDescription>
        <Row justify="space-around">
          {tabsContent[activeTab].links?.map((link: any) =>
            link.href ? (
              <InfoButtonHref
                key={link.label}
                href={
                  tabsContent[activeTab].title === 'Questionário Merenda Escolar' 
                    ? linkMerenda 
                    : tabsContent[activeTab].title === 'Denúncia de Bullying' 
                    ? linkDenunciaEscolar 
                    : link.href
                }
                target="_blank"
              >
                {link.label}
              </InfoButtonHref>
            ) : (
              <InfoButton key={link.label} to={link.path}>
                {link.label}
              </InfoButton>
            ),
          )}
        </Row>
      </InfoCardContent>
    </FlexWrapper>
  )
}